import { takeEvery, put, fork, call, all, select } from 'redux-saga/effects';
import * as agencySlice from './agencySlice';
import * as uiSlice from '../../../UI/redux/uiSlice';
import { authReducerActions, authSagaActions } from '../../../Auth';
import { getAllAgenciesApi } from './agencyAPI';


export function* onLoadAgencyStartAsync(){

    try{
        
        yield put(agencySlice.actions.startCall({ callType: agencySlice.callTypes.list }));

        const getAuth = (state) => state.auth;
        const auth = yield select(getAuth);

        if(!auth.userName || !auth.sessionKey){
            yield put(authSagaActions.logout());
            return
        }

        let reqBody = {
            username: auth.userName,
            key: auth.sessionKey
        };

        const response = yield call(getAllAgenciesApi, reqBody);        

        if(response.status === 200){
            let totalCount = response.data.length;
            let entities = response.data;
            yield put(agencySlice.actions.agenciesFetched({totalCount, entities}));
        }
    }
    catch(error){

        console.log(error);

        if(error.response.status === 403){

            yield put(authReducerActions.loggedOut());
            
        } else {
                if(error.response.status === 404){

                let status = error.response.status;
                let msg = "Page Not Found.";

                yield put(uiSlice.actions.error({ status, msg }));
            } else if(error.response.status === 500){

                let status = error.response.status;
                let msg = "Internal Error";

                yield put(uiSlice.actions.error({ status, msg }));
            }

            yield put(uiSlice.actions.showNotification({
                status:"error",
                title:"Error",
                message: "There was an error retrieving agency information."
            }));

            yield put(agencySlice.actions.catchError({
                callType: agencySlice.callTypes.list,
                error: "There was an error retrieving agency information."
            }));
        }
    }

};

export const actionTypes = {

    FetchAgencies: "[FetchAgencies] Fetch Agencies API Action"
};

export const actions = {

    fetchAgencies: () => ({ type: actionTypes.FetchAgencies, payload: { undefined } })
  
};

export function* fetchAgencies(){

    yield takeEvery(actionTypes.FetchAgencies, onLoadAgencyStartAsync);    
};


const fSagas = [fork(fetchAgencies)];

export function* saga(){
    yield all ([...fSagas]);
};








